class VideoEmbed {
  constructor() {
    this.players = {};

    const videoBlocks = document.querySelectorAll('[data-video-url]');

    if (videoBlocks && videoBlocks.length > 0) {
      this.loadYouTubeAPI();
      videoBlocks.forEach((videoBlock) => {
        this.setupVideo(videoBlock);
      });
    }
  }

  loadYouTubeAPI() {
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  setupVideo(videoBlock) {
    const videoUrl = videoBlock.getAttribute('data-video-url');
    if (!videoUrl) {
      console.error('Video URL is missing in the data attribute.');
      return;
    }

    const videoId = this.extractVideoId(videoUrl);
    if (!videoId) {
      console.error('Invalid YouTube video URL:', videoUrl);
      return;
    }

    const thumbUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
    const thumbLowResUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    const thumb = document.createElement('div');
    thumb.className = 'video-embed__thumb';

    // Preload the main image
    const img = new Image();
    img.onload = function () {
      if (this.naturalWidth < 1280 || this.naturalHeight < 720) {
        thumb.style.backgroundImage = `url('${thumbLowResUrl}')`;
      } else {
        thumb.style.backgroundImage = `url('${thumbUrl}')`;
      }
    };
    img.onerror = function () {
      thumb.style.backgroundImage = `url('${thumbLowResUrl}')`;
    };
    img.src = thumbUrl;

    //thumb.style.backgroundImage = `url('${thumbUrl}')`;
    videoBlock.appendChild(thumb);

    const playButton = document.createElement('button');
    playButton.className = 'video-embed__button';
    playButton.setAttribute('aria-label', 'Play Video');
    videoBlock.appendChild(playButton);

    if (!videoBlock.hasAttribute('data-video-teaser')) {
      playButton.addEventListener('click', (event) => {
        event.preventDefault();
        this.createPlayer(videoBlock, videoId, thumb, playButton);
      });

      this.observeVisibility(videoBlock, videoId);
    }
  }

  extractVideoId(url) {
    const match =
      // eslint-disable-next-line compat/compat
      url.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/.*(?:v=|\/)([\w-]+)/) ||
      // eslint-disable-next-line compat/compat
      url.match(/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([\w-]+)/);
    return match ? match[1] : null;
  }

  createPlayer(videoBlock, videoId, thumb, playButton) {
    const iframeContainer = document.createElement('div');
    const iframeId = `youtube-player-${videoId}`;
    iframeContainer.id = iframeId;
    iframeContainer.className = 'video-embed__iframe-container';

    if (thumb) {
      thumb.style.display = 'none';
    }
    if (playButton) {
      playButton.style.display = 'none';
    }

    videoBlock.appendChild(iframeContainer);

    if (window.YT && window.YT.Player) {
      // Youtube defined on window layer
      // eslint-disable-next-line no-undef
      this.players[videoId] = new YT.Player(iframeId, {
        videoId: videoId,
        events: {
          onReady: this.onPlayerReady,
        },
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
          controls: 1,
        },
      });
    } else {
      window.onYouTubeIframeAPIReady = () => {
        // Youtube defined on window layer
        // eslint-disable-next-line no-undef
        this.players[videoId] = new YT.Player(iframeId, {
          videoId: videoId,
          events: {
            onReady: this.onPlayerReady,
          },
          playerVars: {
            autoplay: 1,
            modestbranding: 1,
            rel: 0,
            controls: 1,
          },
        });
      };
    }
  }

  onPlayerReady(event) {
    event.target.playVideo();
  }

  pauseVideo(videoId) {
    if (this.players[videoId] && this.players[videoId].pauseVideo) {
      this.players[videoId].pauseVideo();
    }
  }

  observeVisibility(videoBlock, videoId) {
    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            this.pauseVideo(videoId);
          }
        });
      },
      { threshold: 0.5 }
    );

    observer.observe(videoBlock);
  }
}

export default VideoEmbed;

export function observeModal(modal) {
  if (!modal) {
    console.error('Modal element not found.');
    return;
  }

  modal.addEventListener('transitionend', (event) => {
    if (event.propertyName === 'opacity' && !modal.classList.contains('is-open')) {
      const iframe = modal.querySelector('iframe');
      const videoId = iframe?.id?.replace('youtube-player-', '');

      if (videoId) {
        this.pauseVideo(videoId);
      }
    }
  });
}
